// extracted by mini-css-extract-plugin
module.exports = {"titleCard":"titlecard_titleCard__wqhhL"};